module.exports = __webpack_public_path__ + "static/media/miscell_question.4dfafbdd.mp3";